export default __webpack_public_path__ + "static/media/delete.10e42677.svg";